export default {
  title: 'Invite to apply job',
  label: {
    job: 'Job',
    subject: 'Subject',
    content: 'Content'
  },
  btn: {
    invite: 'Invite'
  },
  message: {
    inviteSuccess: 'Invite Success',
    inviteNoEmailAccount: 'This candidate do not have an email address, we cannot invite this candidate currently. Our SMS invitation is under developing. Coming SOON!',
    inviteOverLimitTimes: 'Exceed the limit of invitation for this user, please come back several days later.',
    inviteFail: 'Invite Failed',
    atLeastOneJob: 'Please select at least one job',
    noJob: 'There are no other job to invite, please create a new job'
  }
}
